function dispatchEventStroage() {
  window.$setSessionStorage = function(key, data) {
    const setEvent = new Event("setItemEvent");
    const storage = {
      setItem: function(k, val) {
        sessionStorage.setItem(k, val);
        // 在event实例上绑定属性
        setEvent.key = k;
        setEvent.newValue = val;
        // 派发对象
        window.dispatchEvent(setEvent);
      },
    };
    return storage.setItem(key, data);
  };
}

export default dispatchEventStroage;
